import { useState, useEffect } from 'react';
import { getSocket } from '../utils/socket';

export default function useSocket() {
  const [socket] = useState(() => getSocket());
  const [connected, setConnected] = useState(false);

  const [error, setError] = useState(null);


  useEffect(() => {
    const handleConnect = () => {
      setConnected(true);
      setError(null);
    };



    const handleDisconnect = () => {
      setConnected(false);
    };

    const handleError = (err) => {
      setError(err);
    };

    socket.on('connect', handleConnect);
    socket.on('disconnect', handleDisconnect);
    socket.on('connect_error', handleError);

    // Set initial connection status
    setConnected(socket.connected);

    return () => {
      socket.off('connect', handleConnect);
      socket.off('disconnect', handleDisconnect);
      socket.off('connect_error', handleError);
    };
  }, [socket]);

  return { socket, connected, error };
}
